import { DocumentStatuses } from './DocumentStatuses';
export const PostProcessingStatuses = [
    DocumentStatuses.ready,
    DocumentStatuses.review_ready,
    DocumentStatuses.validated
];
